import axios from 'axios';
import Chartkick from 'chartkick';
import Chart from 'chart.js';
import 'hammerjs';
import 'chartjs-plugin-zoom';
Chartkick.use(Chart);

let start = moment().subtract(6, 'days');
let end = moment();

const formatMovementsDaterange = function (start, end) {
  $('#movements_daterange span')
    .html(start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY'))
    .trigger('change');
  $('#movements_daterange_2 span')
    .html(start.format('MMMM D, YYYY') + ' - ' + end.format('MMMM D, YYYY'))
    .trigger('change');
};

const updateMovementsPerItemPerDateChart = function () {
  const params = {
    start_at: moment(
      $('#movements_daterange span').text().split(' - ')[0],
      'MMMM D, YYYY'
    ).format(),
    end_at: moment(
      $('#movements_daterange span').text().split(' - ')[1],
      'MMMM D, YYYY'
    ).format(),
    inventory_item_id: $('#movements_per_item_inventory_item_id').val(),
  };

  axios
    .get('/general_warehouse_reports/movements_per_item_per_date', {
      params,
    })
    .then((response) => {
      let chart = Chartkick.charts['movements-per-item-per-date-chart'];
      chart.updateData(response.data);
    })
    .catch((error) => {
      console.log(error.response.data);
    });
};

const updateMovementsPerDateChart = function () {
  const params = {
    start_at: moment(
      $('#movements_daterange_2 span').text().split(' - ')[0],
      'MMMM D, YYYY'
    ).format(),
    end_at: moment(
      $('#movements_daterange_2 span').text().split(' - ')[1],
      'MMMM D, YYYY'
    ).format(),
  };

  axios
    .get('/general_warehouse_reports/movements_per_date', {
      params,
    })
    .then((response) => {
      let chart = Chartkick.charts['movements-per-date-chart'];
      chart.updateData(response.data);
    })
    .catch((error) => {
      console.log(error.response.data);
    });
};

document.addEventListener('turbolinks:load', function () {
  $('#movements_per_item_inventory_item_id').select2({
    placeholder: 'Buscar items en almacén (código o descripción)',
    minimumInputLength: 2,
    width: '100%',
  });

  // Format daterange of charts
  $('.warehouse_chart_predefined_daterange').daterangepicker(
    {
      startDate: start,
      endDate: end,
      locale: {
        applyLabel: 'Aplicar',
        cancelLabel: 'Cancelar',
        customRangeLabel: 'Rango personalizado',
      },
      showDropdowns: true,
      ranges: {
        Hoy: [moment().startOf('day'), moment().endOf('day')],
        Ayer: [
          moment().subtract(1, 'days').startOf('day'),
          moment().subtract(1, 'days').endOf('day'),
        ],
        'Últimos 7 días': [
          moment().subtract(6, 'days').startOf('day'),
          moment().endOf('day'),
        ],
        'Últimos 30 días': [
          moment().subtract(29, 'days').startOf('day'),
          moment().endOf('day'),
        ],
        'Este mes': [moment().startOf('month'), moment().endOf('month')],
        'Mes pasado': [
          moment().subtract(1, 'month').startOf('month'),
          moment().subtract(1, 'month').endOf('month'),
        ],
      },
    },
    formatMovementsDaterange
  );
  formatMovementsDaterange(start, end);

  /* movements_per_item_per_date report (chart)
   Dynamically update movements_per_item_per_date chart when a date range or item is selected */
  $('#movements_daterange span').on(
    'change',
    updateMovementsPerItemPerDateChart
  );
  $('#movements_per_item_inventory_item_id').on(
    'change',
    updateMovementsPerItemPerDateChart
  );
  $('#movements-per-item-per-date-zoom-reset-btn').on('click', function () {
    Chartkick.charts['movements-per-item-per-date-chart'].chart.resetZoom();
  });

  /* movements_per_date report (chart)
  Dynamically update movements_per_date chart when a date range is selected */
  $('#movements_daterange_2 span').on(
    'change',
    updateMovementsPerDateChart
  );
  $('#movements-per-date-zoom-reset-btn').on('click', function () {
    Chartkick.charts['movements-per-date-chart'].chart.resetZoom();
  });

  // inventory report
  $(
    '#report-by-code-1, #report-by-family-1, #report-by-type-1, #report-by-price-1, #report-by-stock-1'
  ).hide();
  $('#by_code_check_1').on('click', function () {
    $('#report-by-code-1').toggle(this.checked);
  });
  $('#by_family_check_1').on('click', function () {
    $('#report-by-family-1').toggle(this.checked);
  });
  $('#by_type_check_1').on('click', function () {
    $('#report-by-type-1').toggle(this.checked);
  });
  $('#by_price_check_1').on('click', function () {
    $('#report-by-price-1').toggle(this.checked);
  });
  $('#by_stock_check_1').on('click', function () {
    $('#report-by-stock-1').toggle(this.checked);
  });

  // physical_inventory report
  $(
    '#report-by-code-2, #report-by-family-2, #report-by-type-2, #report-by-price-2, #report-by-stock-2'
  ).hide();
  $('#by_code_check_2').on('click', function () {
    $('#report-by-code-2').toggle(this.checked);
  });
  $('#by_family_check_2').on('click', function () {
    $('#report-by-family-2').toggle(this.checked);
  });
  $('#by_type_check_2').on('click', function () {
    $('#report-by-type-2').toggle(this.checked);
  });
  $('#by_price_check_2').on('click', function () {
    $('#report-by-price-2').toggle(this.checked);
  });
  $('#by_stock_check_2').on('click', function () {
    $('#report-by-stock-2').toggle(this.checked);
  });

  // valued_inventory report
  $(
    '#report-by-code-3, #report-by-family-3, #report-by-type-3, #report-by-price-3, #report-by-stock-3'
  ).hide();
  $('#by_code_check_3').on('click', function () {
    $('#report-by-code-3').toggle(this.checked);
  });
  $('#by_family_check_3').on('click', function () {
    $('#report-by-family-3').toggle(this.checked);
  });
  $('#by_type_check_3').on('click', function () {
    $('#report-by-type-3').toggle(this.checked);
  });
  $('#by_price_check_3').on('click', function () {
    $('#report-by-price-3').toggle(this.checked);
  });
  $('#by_stock_check_3').on('click', function () {
    $('#report-by-stock-3').toggle(this.checked);
  });

  // inventory_receipts report
  $(
    '#report-by-code-4, #report-by-date-1, #report-by-account-1, #report-by-family-4, #report-by-type-4, #report-by-price-4, #report-by-entry-amount-1'
  ).hide();
  $('#by_code_check_4').on('click', function () {
    $('#report-by-code-4').toggle(this.checked);
  });
  $('#by_date_check_1').on('click', function () {
    $('#report-by-date-1').toggle(this.checked);
  });
  $('#by_account_check_1').on('click', function () {
    $('#report-by-account-1').toggle(this.checked);
  });
  $('#by_family_check_4').on('click', function () {
    $('#report-by-family-4').toggle(this.checked);
  });
  $('#by_type_check_4').on('click', function () {
    $('#report-by-type-4').toggle(this.checked);
  });
  $('#by_price_check_4').on('click', function () {
    $('#report-by-price-4').toggle(this.checked);
  });
  $('#by_entry_amount_check_1').on('click', function () {
    $('#report-by-entry-amount-1').toggle(this.checked);
  });

  // inventory_issues report
  $(
    '#report-by-code-5, #report-by-date-2, #report-by-account-2, #report-by-family-5, #report-by-type-5, #report-by-price-5, #report-by-exit-amount-1'
  ).hide();
  $('#by_code_check_5').on('click', function () {
    $('#report-by-code-5').toggle(this.checked);
  });
  $('#by_date_check_2').on('click', function () {
    $('#report-by-date-2').toggle(this.checked);
  });
  $('#by_account_check_2').on('click', function () {
    $('#report-by-account-2').toggle(this.checked);
  });
  $('#by_family_check_5').on('click', function () {
    $('#report-by-family-5').toggle(this.checked);
  });
  $('#by_type_check_5').on('click', function () {
    $('#report-by-type-5').toggle(this.checked);
  });
  $('#by_price_check_5').on('click', function () {
    $('#report-by-price-5').toggle(this.checked);
  });
  $('#by_exit_amount_check_1').on('click', function () {
    $('#report-by-exit-amount-1').toggle(this.checked);
  });
});
